export const ROUTE_LIST_SHUTDOWNS = '/shutdowns';
export const ROUTE_LIST_USERS = '/admin/users';
